module.exports = __webpack_public_path__ + "html/page-not-found.template.html";